import { AsyncPipe, NgIf } from '@angular/common';
import { Component} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslocoDirective } from '@jsverse/transloco';
import { Store } from '@ngrx/store';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { map, Observable } from 'rxjs';
import { ASSET_CONSTANTS } from '../../../shared/constants/asset-constants';
import { selectAuthUser } from '../../../store/auth/auth.selectors';
import { User } from '../../../store/auth/auth.state';
import { MBContentContainer } from '../mb-content-container/mb-content-container.component';
import { MbDrawerComponent } from '../mb-drawer/mb-drawer.component';
import { MBLanguageSelectorComponent } from '../mb-language-selector/mb-language-selector.component';
import { MbLogoComponent } from '../mb-logo/mb-logo.component';
import { UserProfileComponent } from '../user-profile/user-profile.component';
import { MBMenuLinksComponent } from "../mb-menu-links/mb-menu-links.component";


@Component({
  selector: 'app-mb-header',
  imports: [
    FormsModule,
    MbLogoComponent,
    NzIconModule,
    NzSelectModule,
    NzInputModule,
    NzFormModule,
    TranslocoDirective,
    NgIf,
    AsyncPipe,
    MBContentContainer,
    MBLanguageSelectorComponent,
    UserProfileComponent,
    MbDrawerComponent,
    MBMenuLinksComponent
],
  templateUrl: './mb-header.component.html',
})
export class MbHeaderComponent {
  user$: Observable<User | null>;
  isAuthenticated$: Observable<boolean>;
  isMobileMenuOpen = false;

  protected readonly ASSET_CONSTANTS = ASSET_CONSTANTS;

  constructor(private store: Store) {
    this.user$ = this.store.select(selectAuthUser);
    this.isAuthenticated$ = this.store
      .select(selectAuthUser)
      .pipe(map((user) => user !== null && user !== undefined));
  }

  toggleMobileMenu(): void {
    this.isMobileMenuOpen = !this.isMobileMenuOpen;
  }

  closeMobileMenu(): void {
    this.isMobileMenuOpen = false;
  }
}
